export const az = {
  title: 'Sağlam Meşə Mənzərələri',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Funksiya',
      value:
        'Bütün yerli biomüxtəlifliyi saxlamaq üçün kifayət qədər böyük olan və 2020-ci ilə kimi heç bir insan dəyişikliyi əlamətləri göstərməyən, dünyanın ən son qalan parçalanmamış meşə landşaftlarını müəyyən edir. Bu təbəqə, həmçinin 2000-ci ildən 2020-ci ilə qədər bütöv Meşə Landşaftlarının miqyasının azalmasını göstərir.',
    },
    {
      label: 'Qətmə',
      value: 'Təxminən 1:1.000.000',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal',
    },
    {
      label: 'Mənbə',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Juravleva, A. Komarova, S. Minnemeyer və E. Esipova. 2017. "Səhranın son sərhədləri: 2000-ci ildən 2013-cü ilə qədər bütöv meşə landşaftlarının itkisinin izlənməsi." Elmdə irəliləyişlər 3: e1600821.',
    },
    {
      label: 'Məzmun tarixi',
      value: 2020,
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'Dünya IFL xəritəsi mütəxəssislər tərəfindən Landsat şəkillərinin vizual şərhi ilə yaradılmışdır. Xəritədə təsvirlərin məkan rezolyusiyasındakı məhdudiyyətlər və bəzi bölgələrdə yerli torpaqdan istifadə praktikası haqqında köməkçi məlumatın olmaması səbəbindən qeyri-dəqiqliklər ola bilər. Bundan əlavə, metodologiya güman edir ki, yollara və ya digər infrastruktura yaxın ərazidə baş verən yanğınlar insanlar tərəfindən törədilə bilər və buna görə də antropogen pozğunluğun bir formasını təşkil edir. Bu fərziyyə, boreal biomdakı IFL dərəcəsinin düzgün qiymətləndirilməməsi ilə nəticələnə bilər.',
    },
    {
      label: 'Lisenziya',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Təhlükəsiz Meşə Landşaftları (IFL) məlumat dəsti meşə zonası daxilində əhəmiyyətli insan fəaliyyəti əlamətləri göstərməyən və bütün yerli biomüxtəlifliyin, o cümlədən geniş çeşidli növlərin canlı populyasiyalarının qorunub saxlanması üçün kifayət qədər böyük olan təbii ekosistemlərin qırılmamış genişliklərini müəyyən edir. IFL sahələrini xəritələşdirmək üçün qlobal səviyyədə tətbiq oluna bilən və asanlıqla təkrarlana bilən bir sıra meyarlar hazırlanmış və tərtib edilmişdir, ikincisi zamanla təkrar qiymətləndirmələrə, eləcə də yoxlamaya imkan verir. IFL əraziləri ən azı 50.000 hektar ölçüdə və minimum eni 10 kilometr olan parçalanmamış landşaftlar kimi müəyyən edilmişdir. Daha sonra 2000-ci il üçün Landsat peyk görüntülərindən xəritələr çəkildi.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Greenpeace, Merilend Universiteti, Dünya Resursları İnstitutu və Şəffaf Dünya. “Tam olmayan meşə mənzərələri. 2000/2013/2016/2020” 31/01/2025-ci ildə Qlobal Meşə Nəzarəti vasitəsilə əldə edilib. www.globalforestwatch.org',
  },
};
